import { LANGUAGE_CONFIGURATION, LANGUAGE_QUERY_PARAM, LanguageCode } from "./i18n.models";

function removeLanguageQueryParam(windowObject: Window | null = window) {
    if (!windowObject) {
        return;
    }

    const currentUrl = new URL(windowObject.location.href);
    currentUrl.searchParams.delete(LANGUAGE_QUERY_PARAM);

    windowObject.history.replaceState({}, "", currentUrl);
}

export function getLanguageQueryParam(windowObject: Window | null = window) {
    if (!windowObject) {
        return null;
    }

    const queryParamLanguage = new URLSearchParams(windowObject?.location.search).get(LANGUAGE_QUERY_PARAM) as LanguageCode | null;
    if (queryParamLanguage && LANGUAGE_CONFIGURATION.availableLanguages.includes(queryParamLanguage)) {
        removeLanguageQueryParam(windowObject);

        return queryParamLanguage;
    }

    return null;
}
